import { useElementSize } from '@vueuse/core';
import type { MaybeRef } from 'vue';
import { computed, shallowRef, toValue } from 'vue';

export function useTableScroll(scrollX: MaybeRef<number> = 702, diffScrollX = 72) {
  const tableWrapperRef = shallowRef<HTMLElement | null>(null);
  const { height: wrapperElHeight } = useElementSize(tableWrapperRef);

  const scrollConfig = computed(() => {
    return {
      y: wrapperElHeight.value - diffScrollX,
      x: toValue(scrollX)
    };
  });

  return {
    tableWrapperRef,
    scrollConfig
  };
}
